import PropTypes from 'prop-types';
import React from 'react';

import GroupLink from '../group_link';
import Link from '../link';

const Badge = ({
	className = '',
	fullWidth = false,
	icon,
	label,
	size = 'md',
	type = 'div',
	variant = 'light',
	withIcon = false,
	...props
}) => {
	const getRandomHSL = (text) => {
		const hashCode = Array.from(text).reduce(
			(acc, char) => char.charCodeAt(0) + ((acc << 5) - acc),
			0,
		);

		const positiveHashCode = Math.abs(hashCode);

		const hue = positiveHashCode % 360;
		const saturation = 85;
		const lightness = 92;

		return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
	};

	const sizes = {
		lg: {
			badge: 'badge-lg',
			icon: 'icon-lg',
			label: '',
		},
		md: {
			badge: '',
			icon: 'lg',
			label: 'sm fw-500 p-1',
		},
		sm: {
			badge: 'badge-sm',
			icon: 'base',
			label: '',
		},
		xs: {
			badge: 'badge-xs',
			icon: 'base',
			label: '',
		},
	};

	const types = {
		button: {
			Component: 'button',
		},
		div: {
			Component: 'div',
		},
		group_link: {
			Component: GroupLink,
		},
		link: {
			Component: Link,
		},
	};

	const variants = {
		booking: 'bg-teal-600',
		color_random: '',
		danger: 'bg-danger',
		dark: 'bg-dark text-white',
		light: 'bg-light',
		outline: 'badge-outline',
		primary: 'bg-primary',
		primary_light: 'bg-primary-light',
		warning: 'bg-mustard text-dark',
		white: 'bg-light bg-white',
	};

	const BadgeType = types[type]?.Component;

	return (
		<>
			<BadgeType
				className={`badge ${className} ${variants[variant]} ${
					sizes[size].badge
				} ${
					withIcon &&
					'd-flex align-items-center justify-content-between py-1 pe-2'
				} ${fullWidth ? 'w-100' : 'fit-content'}`}
				style={{ backgroundColor: getRandomHSL(label) }}
				{...props}
			>
				<span className={`${withIcon && 'me-1'} ${sizes[size].label}`}>
					{label}
				</span>
				{withIcon && <div className={`${sizes[size].icon}`}>{icon}</div>}
			</BadgeType>
		</>
	);
};

Badge.propTypes = {
	className: PropTypes.string,
	fullWidth: PropTypes.bool,
	icon: PropTypes.object,
	label: PropTypes.string,
	labelSize: PropTypes.string,
	size: PropTypes.string,
	type: PropTypes.string,
	variant: PropTypes.string,
	withIcon: PropTypes.bool,
};

export default Badge;
